<template>
  <div>
    <v-toolbar flat color="white" dense style="margin-bottom:0px">
      <div style="width:200px;">
        <date-range-picker
          v-model="dateRange"
          @input="loadCancelled()"
        ></date-range-picker>
      </div>
      <v-spacer></v-spacer>
      <div style="width:200px;">
        <v-text-field
          v-model="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </div>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      v-model="selectedOrders"
      :items="orders"
      :search="search"
      :loading="true"
      item-key="id"
      dense
      class="elevation-1 orders-table"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="headerCell" slot-scope="{ header }">
        <div
          class="subheading font-weight-light text-primary text--darken-3"
          v-text="header.text"
        />
        <div class="font-weight-light text--darken-4" v-text="header.desc" />
      </template>

      <template slot="items" slot-scope="props">
        <td>
          {{ props.item.tracking_id }}
        </td>
        <td>
          <table>
            <tr :key="itm.id" v-for="itm in props.item.items">
              <td :rowspan="itm.variants.length || 1">
                {{ itm.name }} <br />
                <small class="grey--text">
                  Price: Rs. {{ discountedPrice(itm) }}
                </small>
              </td>
              <td v-if="!itm.variants.length" :colspan="3"></td>
              <template v-for="v in itm.variants">
                <td :key="v.id + 'a'">{{ v.label }}</td>
                <td :key="v.id + 'b'">{{ v.value.name }}</td>
                <td :key="v.id + 'c'">{{ v.value.price }}</td>
              </template>
              <td :rowspan="itm.variants.length || 1">
                {{ itm.quantity }}
              </td>
              <td :rowspan="itm.variants.length || 1">
                Rs. {{ itm.quantity * discountedPrice(itm) }}
              </td>
            </tr>
          </table>
        </td>
        <td>
          {{ props.item.address.name }} <br />
          {{ props.item.address.house_number }} <br />
          {{ props.item.address.apartment }} <br />
          {{ props.item.address.area }} <br />
          {{ props.item.address.city }} - {{ props.item.address.pincode }}
          <br />
          Phone - {{ props.item.address.phone }} <br />
        </td>
        <td class="text-xs-center">{{ props.item.payment_method }}</td>
        <td class="text-xs-right">
          <strong>Rs. {{ props.item.grand_total }}</strong>
        </td>
        <td class="text-xs-center text-no-wrap">
          {{ new Date(props.item.cancelled_on).toLocaleDateString() }}
        </td>
        <!-- <td class="text-xs-center text-no-wrap">
          {{ props.item.cancel_reason }}
        </td> -->
      </template>
    </v-data-table>
  </div>
</template>
<script type="text/javascript">
import api from '@/api';
import DateRangePicker from '../date-range-picker';
export default {
  data() {
    return {
      search: '',
      selectedOrders: [],
      orders: [],
      headers: [],
      dialog: false,
      dateRange: [new Date(), new Date()],
    };
  },
  components: { DateRangePicker },
  methods: {
    loadCancelled() {
      let loader = this.$loading.show();
      let range = this.dateRange;
      api
        .get('orders/bulk/cancelled/', {
          params: {
            from: range[0].toDateString(),
            to: range[1].toDateString(),
          },
        })
        .then(r => {
          this.orders = r.data;
          loader.hide();
        });
    },
  },
  created() {
    this.headers = [
      {
        sortable: false,
        text: 'Order Id',
        value: 'id',
      },
      {
        sortable: false,
        text: 'Items',
        value: 'items',
        desc: 'Name Label Qty Price',
      },
      {
        sortable: false,
        text: 'Buyer Details',
        value: 'address',
      },
      {
        sortable: false,
        text: 'Payment Mode',
        value: 'payment_mode',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Amount',
        value: 'total',
        align: 'center',
        desc: 'subtotal + extra charges',
      },
      {
        sortable: false,
        text: 'Date',
        value: 'created',
        align: 'center',
      },
      // {
      //   sortable: false,
      //   text: 'Reason to cancel',
      //   value: 'cancel_reason',
      //   align: 'center',
      // },
    ];
  },
};
</script>
